var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-partition',{attrs:{"title":_vm.title}},[_c('Table',{ref:"mt",attrs:{"columns":_vm.columns,"data":_vm.list,"height":"350","editMode":"grid"},scopedSlots:_vm._u([{key:"degree",fn:function(ref){
var row = ref.row;
var column = ref.column;
var cellEditing = ref.cellEditing;
return [_c('cell-input-number',{attrs:{"row":row,"column":column,"cellEditing":cellEditing,"field":"degree"},on:{"on-change":_vm.degreeChange}})]}},{key:"price",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.price)+" "+_vm._s(row.unit)+" ")]}},{key:"amount",fn:function(ref){
var row = ref.row;
var column = ref.column;
var cellEditing = ref.cellEditing;
return [_c('cell-input-number',{attrs:{"row":row,"column":column,"cellEditing":cellEditing,"field":"amount"},on:{"on-change":_vm.expenseChange}})]}}])}),_c('div',{staticClass:"totalPrice"},[_vm._v("清算统计："+_vm._s(_vm._f("currency")(_vm.totalPrice))+"元")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }